import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import logo from "../images/logo.png";
import "./Navbar.css";
import { FaHome, FaInfoCircle, FaListUl, FaPhoneAlt, FaBriefcase } from "react-icons/fa";

export default function Navbar() {
  const [click, setClick] = useState(false);
  const [navbar, setNavbar] = useState(false);
  
  const handleClick = () => {
    setClick(!click);
    if (!click) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  };
  
  const closeMobileMenu = () => {
    setClick(false);
    document.body.style.overflow = 'auto';
  };

  const changeBackground = () => {
    if (window.scrollY >= 60) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", changeBackground);
    return () => {
      window.removeEventListener("scroll", changeBackground);
    };
  }, []);

  useEffect(() => {
    // Cleanup the overflow property on unmount
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (
    <>
      <nav className={navbar ? "navbar active" : "navbar"}>
        <div className="container nav-container">
          <NavLink exact to="/" className="nav-logo" onClick={closeMobileMenu}>
            <img src={logo} alt="NamStack Logo" />
            <div className="logo-text">
              <span className="logo-text-main">NamStack</span>
              <span className="logo-text-sub">Technology Solutions</span>
            </div>
            <div className="logo-shape"></div>
          </NavLink>

          <div className="menu-icon" onClick={handleClick}>
            <div className={click ? "hamburger active" : "hamburger"}>
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
            </div>
          </div>

          <ul className={click ? "nav-menu active" : "nav-menu"}>
            <li className="nav-item">
              <NavLink
                exact
                to="/"
                activeClassName="active"
                className="nav-links"
                onClick={closeMobileMenu}
              >
                <FaHome className="nav-icon" />
                <span>Home</span>
                <div className="nav-link-indicator"></div>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                exact
                to="/about"
                activeClassName="active"
                className="nav-links"
                onClick={closeMobileMenu}
              >
                <FaInfoCircle className="nav-icon" />
                <span>About Us</span>
                <div className="nav-link-indicator"></div>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                exact
                to="/services"
                activeClassName="active"
                className="nav-links"
                onClick={closeMobileMenu}
              >
                <FaListUl className="nav-icon" />
                <span>Services</span>
                <div className="nav-link-indicator"></div>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                exact
                to="/portfolio"
                activeClassName="active"
                className="nav-links"
                onClick={closeMobileMenu}
              >
                <FaBriefcase className="nav-icon" />
                <span>Portfolio</span>
                <div className="nav-link-indicator"></div>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                exact
                to="/contact"
                activeClassName="active"
                className="nav-links contact-link"
                onClick={closeMobileMenu}
              >
                <FaPhoneAlt className="nav-icon" />
                <span>Contact Us</span>
                <div className="nav-link-indicator"></div>
              </NavLink>
            </li>
            <div className="nav-blob"></div>
          </ul>
        </div>
      </nav>
      {click && <div className="mobile-overlay" onClick={closeMobileMenu}></div>}
    </>
  );
}
